import { defineComponent as A, useCssVars as N, useAttrs as z, inject as H, computed as m, ref as p, watch as v, nextTick as P, onMounted as j, openBlock as l, createElementBlock as r, Fragment as D, createElementVNode as R, mergeProps as M, unref as c, createBlock as y, withCtx as u, createVNode as f, withModifiers as x, createCommentVNode as d, normalizeClass as _, renderSlot as k, Transition as C } from "vue";
import { TableBodyRowPropsSymbol as F, Size as L, getTrStyleClasses as U } from "./novoui-vuejs76.js";
import h from "./novoui-vuejs44.js";
import q from "./novoui-vuejs30.js";
import G from "./novoui-vuejs12.js";
const J = ["id", "data-testid"], K = ["id:", "data-testid"], O = ["id", "data-testid"], Q = { class: "table-body-row-details-td-wrapper" }, W = {
  key: 0,
  class: "table-body-row-details-transition-helper"
}, ae = /* @__PURE__ */ A({
  __name: "NTr",
  props: {
    rowId: { default: null },
    isRowExpanded: { type: Boolean, default: !1 },
    dataTestid: { default: void 0 },
    disabled: { type: Boolean }
  },
  emits: ["tr:click"],
  setup(I, { emit: S }) {
    N((e) => ({
      "277caf2e": i.value
    }));
    const $ = S, { class: g, ...T } = z(), t = I, a = H(F, {
      selectedRowIdsSetRef: {},
      selectableRowRef: !1,
      selectRow: () => {
      },
      updateDisabledRow: () => {
      },
      expandableRowRef: !1,
      bodySizeRef: L.md,
      disableExpandAnimationsRef: !1
    }), w = m({
      get() {
        return a.selectedRowIdsSetRef.includes(t.rowId ?? "");
      },
      set(e) {
        return a.selectedRowIdsSetRef.includes(t.rowId ?? e);
      }
    }), E = m(() => U(a, t, g)), o = p(!1), i = p("0"), s = p();
    v(
      () => t.isRowExpanded,
      (e) => {
        o.value = e, i.value = s.value ? `${s.value.clientHeight}px` : "0";
      },
      { immediate: !0 }
    ), v(o, async (e) => {
      await P(), e ? i.value = s.value ? `${s.value.clientHeight}px` : "0" : i.value = "0";
    });
    const V = (e) => {
      o.value = !o.value;
    }, b = (e) => {
      t.disabled || (a.selectableRowRef && a.selectRow(t.rowId), a.expandableRowRef && V(), $("tr:click", e));
    };
    return j(() => {
      t.disabled && a.updateDisabledRow(t.rowId);
    }), (e, n) => (l(), r(D, null, [
      R("tr", M({
        id: e.rowId,
        class: E.value,
        onClick: b,
        "data-testid": t.dataTestid
      }, T), [
        c(a).selectableRowRef ? (l(), y(h, {
          key: 0,
          action: !0
        }, {
          default: u(() => [
            f(q, {
              modelValue: w.value,
              "onUpdate:modelValue": n[0] || (n[0] = (B) => w.value = B),
              onChange: b,
              onClick: n[1] || (n[1] = x(() => {
              }, ["stop"])),
              "aria-label": "select-row",
              disabled: e.disabled
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        })) : d("", !0),
        c(a).expandableRowRef ? (l(), y(h, {
          key: 1,
          action: !0
        }, {
          default: u(() => [
            f(G, {
              size: 16,
              class: _(["table-row-action-expand", { "table-row-action-expand-active": o.value }]),
              icon: "chevronRight",
              onClick: x(b, ["stop"])
            }, null, 8, ["class"])
          ]),
          _: 1
        })) : d("", !0),
        k(e.$slots, "default", {}, void 0, !0)
      ], 16, J),
      f(C, {
        "enter-from-class": "table-body-row-details-content-enter-from",
        "enter-active-class": "table-body-row-details-content-enter-active",
        "leave-to-class": "table-body-row-details-content-leave-to",
        "leave-active-class": "table-body-row-details-content-leave-active"
      }, {
        default: u(() => [
          o.value ? (l(), r("tr", {
            key: 0,
            "id:": `${t.rowId}-expansion`,
            "data-testid": `${t.dataTestid}-expanded`,
            ref_key: "expandedContent",
            ref: s,
            class: _(["table-body-row-details", { "table-body-row-details-active": o.value }])
          }, [
            k(e.$slots, "details", {}, void 0, !0)
          ], 10, K)) : d("", !0)
        ]),
        _: 3
      }),
      c(a).expandableRowRef && !c(a).disableExpandAnimationsRef ? (l(), r("tr", {
        key: 0,
        id: `${e.rowId}-expansion-helper`,
        "data-testid": t.dataTestid
      }, [
        R("td", Q, [
          f(C, {
            "enter-from-class": "table-body-row-details-enter-from",
            "enter-active-class": "table-body-row-details-enter-active",
            "leave-to-class": "table-body-row-details-leave-to",
            "leave-active-class": "table-body-row-details-leave-active"
          }, {
            default: u(() => [
              o.value ? (l(), r("div", W)) : d("", !0)
            ]),
            _: 1
          })
        ])
      ], 8, O)) : d("", !0)
    ], 64));
  }
});
export {
  ae as default
};
